import React, { useState } from 'react';
import TopHeader from '@awp/TopHeader';
import Footer from '@awp/Footer';
import { Container } from 'react-bootstrap';
import HeaderMenu from '@components/Navigation/HeaderMenu';

const DisabledAccount = ({ isBarExpanded, setIsBarExpanded }) => {
  const [currentUser, setCurrentUser] = useState(null);

  const expandedClick = () => {
    setIsBarExpanded(isBarExpanded ? false : 'expanded');
  };

  return (
    <>
      <TopHeader user={currentUser} expandedClick={expandedClick} isBarExpanded={isBarExpanded} />
      <HeaderMenu expandedClick={expandedClick} isBarExpanded={isBarExpanded} />
      <Container>
        <div className="card mt-3">
          <div id="header_title" className="card-header">
            <h2 style={{ height: '3rem', verticalAlign: 'middle', display: 'table-cell' }}>Your Account is Disabled</h2>
          </div>

          <div className="card-body">
            <h3>You are unable to access the Snow Avalanche and Weather System.</h3>
            <p>
              If you have any questions, please email IT support at this email:{' '}
              <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
            </p>
            <br />
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default DisabledAccount;
